import { buildClassMap } from '../utilities/index';
import { DefaultFontStyles } from '../styles/index';
export var FontClassNames = buildClassMap(DefaultFontStyles);
//# sourceMappingURL=FontClassNames.js.map